import { LoadingIcon } from '@/app/svgs/LoadingIcon';

interface LoadingProps {
  children: React.ReactNode;
}

export function Loading({ children }: LoadingProps) {
  return (
    <div className="min-h-dvh size-full flex justify-center items-center bg-white">
      <div className="flex flex-col gap-10 justify-center items-center max-w-2xl mx-4 md:mx-0">
        <div className="animate-spin">
          <LoadingIcon />
        </div>
        <div className="font-normal text-xl leading-[30px] text-gray-600 text-center">
          {children}
        </div>
      </div>
    </div>
  );
}
